"use strict";
/**
 * zamienia pierwszą literę każdego wyrazu na wielką, pozostałe na małe
 *
 * @param value wartośc do zmiany
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalize = void 0;
function capitalize(value) {
    //return value.toLocaleLowerCase().replace(/\w[^\s-]*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())));
    var tt = value.toLocaleLowerCase();
    // let tt = value;
    var result = '';
    var isFirstLetter = true;
    for (var i = 0; i < tt.length; i++) {
        var c = tt[i];
        if (c == ' ' || c == '\t' || c == '\r' || c == '\n' || c == '-' || c == ',' || c == '.' || c == '_') {
            result += c;
            isFirstLetter = true;
        }
        else {
            if (isFirstLetter) {
                result += c.toLocaleUpperCase();
                isFirstLetter = false;
            }
            else {
                result += c;
            }
        }
    }
    return result;
}
exports.capitalize = capitalize;
exports.default = capitalize;
//# sourceMappingURL=capitalize.js.map